// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__27lYX","image":"Header_image__27iv6","name":"Header_name__tBCKk","info":"Header_info__1ck11","infoRow":"Header_infoRow__2JZsJ"};